<template>
    <div>
        <van-nav-bar
                title="批量划卡"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />


            <van-field
                    v-model="form.start"
                    name="开始卡号"
                    label="开始卡号"
                    clearable
                    required
                    placeholder="开始卡号"
                    message="请填写开始卡号"
            >
                <template #button v-if="wxReady">
                    <van-button size="small" type="primary" @click="handleScan('start')">扫条码</van-button>
                </template>
            </van-field>
            <van-field
                    v-model="form.end"
                    name="结束卡号"
                    label="结束卡号"
                    placeholder="结束卡号"
                    clearable
                    required
                    message="请填写结束卡号"

            >
                <template #button  v-if="wxReady">
                    <van-button size="small" type="primary" @click="handleScan('end')">扫条码</van-button>
                </template>
            </van-field>
        <div style="position: relative">
        <van-field
                v-model="agentName"
                name="代理商"
                label="代理商"
                placeholder="代理商名称"
                right-icon="search-o"
                clearable
                required
                message="请输入完整的代理商名称"
                @input="searchAgent"
                @focus="show=true"
        />
            <ul style="" v-show="show">
                <li v-for="(name,id) in childList" v-if="name" @click="check(id,name)" :key=id>{{name}}</li>
            </ul>
        </div>

        <van-cell is-link title="数量" :value="cardLength(form.end,form.start)"/>
            <div style="margin: 16px;">
                <van-button round block type="info" @click="onSubmit">
                    提交
                </van-button>
            </div>

    </div>
</template>

<script>
  import wx from "weixin-js-sdk"
    export default {
        name: "dividecard",
        data() {
            return {
                childList:[],
                show:false,
                agentName:'',
                children:[],
              wxReady:false,
                form:{
                    start:'',
                    end:'',
                    agentID:''
                }
            };
        },
        methods: {
            onClickLeft(){
                window.history.go(-1)
            },
            check(id,name){
                this.form.agentID = id;
                this.agentName = name;
                this.show = false
            },
            onSubmit(){
                if(!this.form.start || !this.form.end || !this.form.agentID){
                    this.$toast.fail('请完善资料再提交');
                    return false;
                }
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                });
                this.fetchDataPost('/cardsection/divide',this.form,(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success({message:res.msg,onClose(){
                            window.history.go(-1)
                            }})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            getAllChildren(){
                this.fetchData('/agent/allChildren', '', (res) => {
                    this.children = res.data
                    this.searchAgent();
                })
            },
            searchAgent(){
                if(!this.agentName){
                    this.childList = this.children
                    return false;
                }
                this.childList = []
                for(let id in this.children){
                    if(this.children[id].indexOf(this.agentName) != -1){
                        this.childList[id+''] = this.children[id]
                    }
                }
            },
            handleScan(key){
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success:(res)=>{
                        if(res.resultStr.includes(',')){
                            this.form[key]= res.resultStr.split(',')[1];
                        }else {
                            this.form[key] = res.resultStr;
                        }

                    }
                })
            },
          cardLength(A, B) {
            A = A.replace(/[^\d]/g,'',A);
            B = B.replace(/[^\d]/g,'',B);

            let result = [];
            (A += ''), (B += '');
            while (A[0] === '0') {
              A = A.substr(1);
            }
            while (B[0] === '0') {
              B = B.substr(1);
            }
            const l = -15;
            let N = '1';
            for (let i = 0; i < -l; i++) {
              N += '0';
            }
            N = parseInt(N);
            while (A !== '' && B !== '') {
              result.unshift(parseInt(A.substr(l)) - parseInt(B.substr(l)));
              A = A.slice(0, l);
              B = B.slice(0, l);
            }
            if (A !== '' || B !== '') {
              let s = B === '' ? 1 : -1;
              A += B;
              while (A !== '') {
                result.unshift(s * parseInt(A.substr(l)));
                A = A.slice(0, l);
              }
            }
            while (result.length !== 0 && result[0] === 0) {
              result.shift();
            }
            let s = '';
            if (result.length === 0) {
              result = 0;
            } else if (result[0] < 0) {
              s = '-';
              for (let i = result.length - 1; i > 0; i--) {
                if (result[i] > 0) {
                  result[i] -= N;
                  result[i - 1]++;
                }
                result[i] *= -1;
                result[i] += '';
                while (result[i].length < -l) {
                  result[i] = '0' + result[i];
                }
              }
              result[0] *= -1;
            } else {
              for (let i = result.length - 1; i > 0; i--) {
                if (result[i] < 0) {
                  result[i] += N;
                  result[i - 1]--;
                }
                result[i] += '';
                while (result[i].length < -l) {
                  result[i] = '0' + result[i];
                }
              }
            }

            if (result) {
              while ((result[0] = parseInt(result[0])) === 0) {
                result.shift();
              }
              result = s + result.join('');
            }
            result = parseInt(result);
            if(result >= 0) result++
            if(result < 0) result--;
            return result
          },
            initWechatJs(){
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/base/jssdk',{url:url},(res)=>{
                    if(res.code){
                        wx.config(res.data);
                        wx.ready(()=>{
                            this.wxReady = true;
                        })
                    }
                })
            },
        },
        created: function () {
            this.getAllChildren();
            this.initWechatJs()
        }
    };
</script>
<style scoped>
    ul{
        position: absolute;
        font-size: .3rem;
        color: #666;
        background: #fff;
        border: 1px solid #ccc;
        padding: .2rem;
        opacity: 1;
        z-index:1050;
        left: 100px;
        width: 200px;
        height: 100px;
        overflow-y: scroll;
    }
    ul li{
        border-bottom: 1px solid #eee;
        padding: 4px 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dividecard.vue